export enum ButtonStatus {
  Upload = 'Upload',
  Received = 'Received',
  Completed = 'Completed',
}
